import { Controller } from "@hotwired/stimulus"

// Sélecteur à deux segments (Écrire / Parler) : un panneau visible à la fois.
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { active: { type: String, default: "ecrire" } }

  connect() { this.render() }

  select(event) {
    this.activeValue = event.currentTarget.dataset.mode
  }

  // Le micro est refusé ou indisponible : on bascule sur l'écriture.
  unavailable() {
    this.activeValue = "ecrire"
  }

  activeValueChanged() { this.render() }

  render() {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.mode === this.activeValue
      tab.classList.toggle("is-active", active)
      tab.setAttribute("aria-selected", active)
    })
    this.panelTargets.forEach((panel) => { panel.hidden = panel.dataset.mode !== this.activeValue })
    if (this.activeValue === "ecrire") this.element.querySelector("textarea")?.focus({ preventScroll: true })
  }
}
